import { render } from "./BrandPortfolioTable.vue?vue&type=template&id=2d9c9f64&scoped=true"
import script from "./BrandPortfolioTable.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioTable.vue?vue&type=script&lang=js"

import "./BrandPortfolioTable.vue?vue&type=style&index=0&id=2d9c9f64&scoped=true&lang=scss"
import "./BrandPortfolioTable.vue?vue&type=style&index=1&id=2d9c9f64&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9c9f64"]])

export default __exports__